import styled from 'styled-components';

import { Colors } from '../utils/style-utils';

export const Anchor = styled.a`
  color: ${Colors.Blue500};
  text-decoration: none;
`;
